import { MutationTree } from 'vuex';
import { StatisticState } from './types';

export const mutations: MutationTree<StatisticState> = {
    setSmsStatisticGroup:(state, data) => {
        state.smsStatisticGroup = data
    },
    setSmsStatisticDetail:(state, data) => {
        state.smsStatisticDetail = data
    },
    pushSmsStatisticDetail:(state, data) => {
        state.smsStatisticDetail = state.smsStatisticDetail.concat(data)
    },
    setSmsStatisticGroupIncoming: (state, data) => {
        state.smsStatisticGroupIncoming = data;
    },
    setSmsStatisticDetailIncoming: (state, data) => {
        state.smsStatisticDetailIncoming = data;
    },
    pushSmsStatisticDetailIncoming: (state, data) => {
        state.smsStatisticDetailIncoming = state.smsStatisticDetailIncoming?.concat(data);
    },
};
